import { useState } from 'react';
import { ReconTypeClient, ReconTypeDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useReconTypeApi = () => {
    const apiClient = new ReconTypeClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: ReconTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createReconType(data);
        } catch (err: any) {
            setError(err.message || 'Error creating ReconType');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: ReconTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateReconType(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating ReconType');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getReconTypeById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching ReconType');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchReconTypes(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching ReconTypes');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteReconType(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting ReconType');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};